import { ROUTES } from 'constants/routes';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CloseIcon from 'svg/CloseIcon';
import MyOceanIcon from 'svg/MyOceanIcon';
import { closeModal } from './actions';
import { MODALS } from './consts';
import ContactSalesModal from './modals/ContactSalesModal';
import selector from './selector';
import useStyles from './styles';

interface IProps {
}

const Modals: React.FC<IProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { modalId } = useSelector(selector);

  const handleClose = useCallback(() => dispatch(closeModal()), []);

  const renderModal = (modal: MODALS) => {
    document.body.style.overflow = 'hidden';

    switch (modal) {
      case MODALS.CONTACT_SALES:
        return <ContactSalesModal onClose={handleClose} />;
    }

    document.body.style.overflow = 'initial';

    return null;
  };

  if (!modalId) {
    document.body.style.overflow = 'initial';

    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.background} onClick={handleClose} />
      <div className={classes.modal}>
        <div className={classes.mobileHeader}>
          <Link to={ROUTES.ROOT} onClick={handleClose}>
            <MyOceanIcon />
          </Link>
          <button type="button" className={classes.cancelButton} onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        {renderModal(modalId)}
      </div>
    </div>
  );
};

export default Modals;
